import React from 'react';
import { unmountComponentAtNode } from 'react-dom';

import { renderWithStore } from 'state';
import AppProductQuestionsAndAnswers from 'apps/productQuestionsAndAnswers';

function initProductQuestionsAndAnswers (pageState, element) {

	const { multiProductSkuChanged, productData, questionsData } = pageState;

	if (element) {

		renderWithStore(
			<AppProductQuestionsAndAnswers
				resetInitialState={multiProductSkuChanged}
				productData={productData}
				questionsData={questionsData}
			/>,
			element
		);

	}

	pageState.qaInitialized = true;

}

function unmountProductQuestionsAndAnswers (element) {

	if (element) {

		unmountComponentAtNode(element);

	}

}

export { unmountProductQuestionsAndAnswers };
export default initProductQuestionsAndAnswers;
